import Divider from "_components/atoms/divider";
import Tabs    from "_components/molecules/tabs";

import TabContent from "../tabContent";

import useStyles from "./styles";

const component = ( {
	tabList,
	activeTab,
	onTabChange,
	isLoading,
	isDepleted,
	list,
	fetchMore,
	updateDeletedPost
} ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<>
			<div className = { classes.tabsContainer }>
				<Tabs
					activeTab = { activeTab }
					list      = { tabList }
					onChange  = { onTabChange }
					variant   = { "fullWidth" }
				/>
			</div>

			<Divider />

			<div className = { classes.contentContainer }>
				<TabContent
					activeTab         = { activeTab }
					fetchMore         = { fetchMore }
					isDepleted        = { isDepleted }
					isLoading         = { isLoading }
					list              = { list }
					updateDeletedPost = { updateDeletedPost }
				/>
			</div>

		</>
	);
};

export default component;